import { Injectable } from '@angular/core';
import { map, Observable, ReplaySubject, shareReplay, Subject, tap } from 'rxjs';
import {
  IndependentCredit,
  InternalGetIndependentCreditRequestParams,
  InternalService,
  ListIndependentCreditsRequestParams,
} from '../../../../projects/tilled-api-client/src';
import { TilledAlert } from '../models/tilled-alert';
import { AlertService } from './alert.service';

@Injectable({
  providedIn: 'root',
})
export class IndependentCreditsAppService {
  private _independentCreditSubject$ = new Subject<IndependentCredit>();
  private _independentCredits$ = new ReplaySubject<IndependentCredit[]>();
  private _independentCreditsCount$ = new ReplaySubject<number>();
  private _independentCreditsHideIC$ = new ReplaySubject<IndependentCredit[]>();

  public independentCredit$: Observable<IndependentCredit> = this._independentCreditSubject$.asObservable();
  public independentCredits$: Observable<IndependentCredit[]> = this._independentCredits$.asObservable();
  public independentCreditsCount$: Observable<number> = this._independentCreditsCount$.asObservable();
  public independentCreditsHideIC$: Observable<IndependentCredit[]> = this._independentCreditsHideIC$.asObservable();

  constructor(
    private _internalService: InternalService,
    private _alertService: AlertService,
  ) {}

  public getIndependentCredit(params: InternalGetIndependentCreditRequestParams): void {
    this._internalService.internalGetIndependentCredit(params).subscribe({
      next: (independentCredit) => {
        this._independentCreditSubject$.next(independentCredit);
      },
      error: (err) => {
        // generic catch all for error responses
        const message: TilledAlert = {
          message: "Could not load independent credit '" + params.id + "'",
          title: 'Server error',
          type: 'error',
        };
        this._alertService.showAlert(message);
      },
    });
  }

  public getAllIndependentCredits(params: ListIndependentCreditsRequestParams): void {
    this._internalService
      .listIndependentCredits(params)
      .pipe(
        tap((result) => this._independentCreditsCount$.next(result.total)),
        map((result) => result.items),
        shareReplay(1),
      )
      .subscribe({
        next: (independentCredits) => {
          this._independentCredits$.next(independentCredits);
        },
        error: (err) => {
          // generic catch all for error responses
          const message: TilledAlert = {
            message: err.error?.message ? err.error.message : 'Could not load all independent credits',
            title: 'Server error',
            type: 'error',
          };
          this._alertService.showAlert(message);
        },
      });
  }

  public getAllIndependentCreditsHideOT(params: ListIndependentCreditsRequestParams): void {
    this._internalService
      .listIndependentCredits(params)
      .pipe(
        map((result) => result.items),
        shareReplay(1),
      )
      .subscribe({
        next: (independentCredits) => {
          this._independentCreditsHideIC$.next(independentCredits);
        },
        error: (err) => {
          // generic catch all for error responses
          const message: TilledAlert = {
            message: err.error?.message ? err.error.message : 'Could not load all independent credits',
            title: 'Server error',
            type: 'error',
          };
          this._alertService.showAlert(message);
        },
      });
  }
}
